<div class="vehicles-page">
  <ysh-table-set
    [dataSource]="dataSource"
    (onItemTap)="didTapItem($event)"
  >
  </ysh-table-set>
</div>

